import {
  Tabs,
  WhiteSpace,
  List,
  Button,
  Modal,
  Switch,
  InputItem,
  Picker,
  Toast,
  Drawer,
} from "antd-mobile-v2";
import "./index.less";
import React, { Component } from "react";
import allUrl from "../../api/allUrl";
import { post, get, postRaw } from "../../api/service/services";
import secsstion from "../../api/service/secsstion";
import tool from "../../api/tool";
import { createForm } from "rc-form";
import RelatedComt from "../../components/Related";
import SentsitiveCont from "../../components/Sensitive";
import { childrenVal } from "./const";
import Preview from "./preview/index";
const Item = List.Item;
let submitData = {};
let errorDataObj = {};
let isData = ["hasPosition", "isAccept", "isArbitrate", "isPublic", "isReview"];
class Volation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 60,
      flagCode: true,
      pathName: "",
      cityData: [],
      leibieData: [],
      drawerOpen: false,
      senFilter: {},
      modal: false,
      cityNameData: [],
      leibieNameData: [],
      fadIn: "",
      open: false,
    };
  }
  // 获取省市县数据
  getData = () => {
    post(
      allUrl.register.getRegnData,
      {},
      {
        "Content-Type": "application/json;charset=UTF-8",
      }
    )
      .then((res) => {
        if (res.success === true && res.code == 200) {
          let data = JSON.parse(res.data);
          let newData = childrenVal(data, ["code", "name"]);
          tool.set("cityData", newData);
          this.setState({ cityData: newData });
        } else {
        }
      })
      .catch((error) => {});
  };
  // 获取问题类别数据
  getCategoryData = () => {
    postRaw(
      allUrl.register.getCategory,
      {
        code: "wentixingzhi",
      },
      {
        "Content-Type": "application/x-www-form-urlencoded",
      }
    ).then((res) => {
      if (res.success === true && res.code == 200) {
        try {
          let data = JSON.parse(res.data);
          let newData = childrenVal(data, ["dicCode", "dicName"]);
          this.setState({ leibieData: newData });
        } catch (error) {}
      } else {
        Toast.info(res.msg, 1);
      }
    });
  };
  // 下一步之前数据提交
  onSubmit = () => {
    this.props.form.validateFields((error, values) => {
      if (error) {
        let errorData = Object.keys(error)[0];
        Toast.info(error[errorData].errors[0].message, 1);
        return;
      }
      let isFlag = Object.keys(this.state.senFilter).filter((item) => {
        return this.state.senFilter[item] !== "";
      });
      if (isFlag.length > 0) {
        let errorText = this.state.senFilter[isFlag[0]];
        if (errorText === "内容包含敏感词") {
        }
        this.ReplyDubmit(values, { type: true });
        Toast.info(errorText, 1);
        return;
      }
      this.ReplyDubmit(values, { type: false });
    });
  };
  componentDidMount() {
    this.getData();
    this.getCategoryData();
    const { location } = this.props;
    this.setState({
      pathName: location.pathname,
    });
  }
  // 被反映人单位选中时触发
  selectData = (data) => {
    const { setFieldsValue } = this.props.form;
    submitData.selectData = data;
    setFieldsValue({ personOrgDes: data.label });
    this.setState({ open: false });
  };
  // 抽屉点击取消时触发的事件
  drawonCancel = () => {
    this.setState({ open: false });
  };
  // 主要观点输入框离开赋值敏感词过滤
  changeBlur = (vals) => {
    this.reSetvalue(vals, "mainAppeal");
  };
  // 事实和理由输入框离开赋值敏感词过滤
  shichangeBlur = (vals) => {
    this.reSetvalue(vals, "complaintReason");
  };
  reSetvalue = (vals, label) => {
    let tvlp = vals.val.replace(/<[^>]+>/gi, "");
    errorDataObj[label] = tvlp;
    if (vals.flag) {
      let obj = {
        ...this.state.senFilter,
        [label]: vals.err ? "敏感词过滤异常" : "内容包含敏感词",
      };
      this.setState({ senFilter: obj });
      this.props.form.setFields({
        [label]: {
          value: vals.val != "" ? vals.val : "",
          errors: [new Error(vals.err ? "敏感词过滤异常" : "内容包含敏感词")],
        },
      });
    } else {
      let obj = { ...this.state.senFilter, [label]: "" };
      this.setState({ senFilter: obj });
      this.props.form.setFields({
        [label]: {
          value: vals.val != "" ? vals.val : "",
          success: [],
        },
      });
    }
  };
  onWrapTouchStart = (e) => {
    // fix touch to scroll background page on iOS
    if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
      return;
    }
    const pNode = this.closest(e.target, ".am-modal-content");
    if (!pNode) {
      e.preventDefault();
    }
  };
  closest(el, selector) {
    const matchesSelector =
      el.matches ||
      el.webkitMatchesSelector ||
      el.mozMatchesSelector ||
      el.msMatchesSelector;
    while (el) {
      if (matchesSelector.call(el, selector)) {
        return el;
      }
      el = el.parentElement;
    }
    return null;
  }
  // 城市选中时的调用
  cityOk = (val) => {
    let newData = [];
    const { cityData } = this.state;
    for (var i = 0; i < val.length; i++) {
      this.filterCityName(val[i], cityData, newData);
    }
    submitData["cityName"] = newData;
    this.setState({ cityNameData: newData });
  };
  // 问题属地选中时的调用
  leibieOk = (val) => {
    let newData = [];
    const { leibieData } = this.state;
    for (var i = 0; i < val.length; i++) {
      this.filterCityName(val[i], leibieData, newData);
    }
    submitData["leibieName"] = newData;
    this.setState({ leibieNameData: newData });
  };
  // 根据key过滤率label
  filterCityName = (val, cityData, newData) => {
    for (var i = 0; i < cityData.length; i++) {
      if (cityData[i].value == val) {
        newData.push(cityData[i].label);
      } else {
        if (cityData[i].children && cityData[i].children.length > 0) {
          this.filterCityName(val, cityData[i].children, newData);
        }
      }
    }
    return newData;
  };
  ReplyDubmit = (dataVal, isType) => {
    let applyType =
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.comiplatType
        ? this.props.location.state.comiplatType
        : "";
    let that = this;
    get(
      allUrl.register.DuplicateResBook,
      {
        applyType: applyType,
        applyUserCode: secsstion.get("acount"),
        complaintOrgCode: submitData.selectData.value,
        complaintType: "1301",
      },
      {
        "Content-Type": "application/json;charset=UTF-8",
      }
    )
      .then((res) => {
        if (res.success == true && res.code == 200) {
          if (res.data === false) {
            Toast.info("您还有同类事项未完结，请关注已提交信访件答复！", 3);
            return;
          }
          that.createEditData(dataVal, isType);
        } else {
          Toast.info(res.msg, 3);
        }
      })
      .catch((error) => {
        Toast.info("接口异常", 3);
      });
  };
  createEditData = (values, isType) => {
    values["cityNameData"] = this.state.cityNameData;
    values["leibieNameData"] = this.state.leibieNameData;
    tool.set("submitData", values);
    if (isType.type) {
      this.succeSubMitData();
      return;
    }
    this.setState({ modal: true });
  };
  // 用户进行提交
  succeSubMitData = () => {
    const { cityNameData, leibieNameData } = this.state;
    let newData = {};
    let values = tool.get("submitData"); // 用户填写数据
    const asscateData = tool.get("asscateData") || []; // 联名人数据
    let applyType =
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.comiplatType
        ? this.props.location.state.comiplatType
        : "";
    isData.forEach((item) => {
      values[item] = values[item] ? "01" : "02";
    });
    let isFlag = Object.keys(this.state.senFilter).filter((item) => {
      return this.state.senFilter[item] !== "";
    });
    values["sheshi"] = submitData.selectData;
    if (Number(submitData.selectData.orgDet) > 1) {
      values["complaintParentOrg"] = submitData.selectData.value;
      values["personOrgDes"] = "";
    } else {
      values["complaintParentOrg"] = submitData.selectData.parentOrgId;
    }
    values["isPublic"] = "02";
    values["AssociateData"] = asscateData;
    values["orgProvinceName"] = submitData["cityName"][0]; // 省中文
    values["orgCityName"] = submitData["cityName"][1]; // 市中文
    values["orgRegionName"] = submitData["cityName"][2]; // 县中文
    values["complaintTypeVal"] = '检举揭发';
    values["mainAppeal"] = errorDataObj["mainAppeal"];
    values["complaintReason"] = errorDataObj["complaintReason"];
    values["orgProvinceCode"] = values["addreOrg"][0];
    values["orgCityCode"] = values["addreOrg"][1];
    values["orgRegionCode"] = values["addreOrg"][2];
    values["uniteCount"] = asscateData.length;
    values["complaintTypeValue"] = "检举揭发";
    values["complaintType"] = "1801";
    newData["pcComplaintJoint"] = values.AssociateData;
    newData["pcComplaintPerson"] = values;
    newData["pcComplaintDetail"] = values;
    newData["applyType"] = applyType;
    newData["dataSource"] = "01";
    newData["approvalStatus"] = "00";
    newData["applyUserCode"] = secsstion.get("acount")
      ? secsstion.get("acount")
      : "";
    newData["applyUserName"] = secsstion.get("nick_name")
      ? secsstion.get("nick_name")
      : ""; // 后期修改
    newData["createDept"] = secsstion.get("qiOrgCode") // 后期修改
    if (isFlag.length > 0) {
      let errorText = this.state.senFilter[isFlag[0]];
      if (errorText === "内容包含敏感词") {
        newData["approvalStatus"] = "01";
        Toast.info("填报内容包含敏感词无法提交", 2, () => {
          this.requestSumitData({
            ...newData,
            refuseReason: "提交内容存敏感词",
          });
        });
      }
      return;
    }
    this.requestSumitData(newData);
    console.log(newData, submitData, "提交总数据");
  };
  //提交请求接口
  requestSumitData = (data) => {
    post(allUrl.register.saveData, data, {
      "Content-Type": "application/json;charset=UTF-8",
    })
      .then((res) => {
        if (res.success === true && res.code == 200) {
          if (data.refuseReason) return;
          this.setState({ modal: false });
          this.props.history.push({ 
            pathname:"/success",
            state:{
                subMiTitle:"事项"
            }
        });
        } else {
          Toast.info(res.msg, 1);
        }
      })
      .catch((error) => {
        Toast.info("提交失败", 1);
      });
  };
  render() {
    const { getFieldProps, getFieldError, resetFields } = this.props.form;
    const { drawerOpen } = this.state;
    const asscateData = tool.get("asscateData") || [];
    const cententData = tool.get("formData");
    return (
      <div className="Volation-wrap">
        <Modal
          visible={this.state.modal}
          transparent
          className="preview-modal"
          maskClosable={false}
          title="预览"
          footer={[
            {
              text: "取消",
              onPress: () => {
                this.setState({ modal: false });
              },
            },
            {
              text: "确定提交",
              onPress: () => {
                this.succeSubMitData();
              },
            },
          ]}
          wrapProps={{ onTouchStart: this.onWrapTouchStart }}
        >
          <Preview />
        </Modal>
        <div
          className={`draw-cont ${this.state.fadIn}`}
          style={{ display: this.state.open ? "block" : "none" }}
        >
          <RelatedComt
            selectData={this.selectData}
            drawonCancel={this.drawonCancel}
            placeholder="请输入被反映人单位关键字"
          />
        </div>
        <form>
          <List style={{ paddingTop: "0px" }}>
            <InputItem
              {...getFieldProps("personName", {
                initialValue:
                  cententData && cententData.personName
                    ? cententData.personName
                    : "",
                rules: [{ required: true, message: "请输入被反映人" }],
              })}
              clear
              error={!!getFieldError("personName")}
              onErrorClick={() => {
                alert(getFieldError("personName").join("、"));
              }}
              labelNumber={8}
              placeholder="请输入被反映人"
              maxLength={50}
            >
              <span style={{ color: "red" }}>*</span> 被反映人
            </InputItem>
            <InputItem
              {...getFieldProps("personOrgDes", {
                initialValue:
                  cententData && cententData.personOrgDes
                    ? cententData.personOrgDes
                    : "",
                rules: [
                  { required: true, message: "请点击搜索选择被反映人单位" },
                ],
              })}
              clear
              error={!!getFieldError("personOrgDes")}
              onErrorClick={() => {
                alert(getFieldError("personOrgDes").join("、"));
              }}
              onFocus={() => {
                document.body.style.overflow = "hidden";
                this.setState({ open: true, fadIn: "fadein" });
              }}
              editable={false}
              labelNumber={8}
              placeholder="请输入被反映人单位名称关键字"
              maxLength={50}
            >
              <span style={{ color: "red" }}>*</span> 被反映人单位
            </InputItem>
            <Picker
              data={this.state.cityData}
              cols={3}
              {...getFieldProps("addreOrg", {
                initialValue:
                  cententData && cententData.addreOrg
                    ? cententData.addreOrg
                    : [],
                rules: [{ required: true, message: "请选择被反映人单位地址" }],
              })}
              title="选择地址"
              onOk={this.cityOk}
            >
              <List.Item arrow="horizontal">
                <span style={{ color: "red" }}>*</span> 被反映人单位地址
              </List.Item>
            </Picker>
            <InputItem
              {...getFieldProps("byAddress", {
                initialValue:
                  cententData && cententData.byAddress
                    ? cententData.byAddress
                    : "",
                rules: [
                  { required: true, message: "请输入被反映人单位详细地址" },
                ],
              })}
              clear
              error={!!getFieldError("byAddress")}
              onErrorClick={() => {
                alert(getFieldError("byAddress").join("、"));
              }}
              placeholder="请输入被反映人详细地址"
              labelNumber={8}
              maxLength={50}
            >
              <span style={{ color: "red", width: "2rem" }}>*</span>{" "}
              被反映人单位详细地址
            </InputItem>
            <InputItem
              {...getFieldProps("personPost", {
                initialValue:
                  cententData && cententData.personPost
                    ? cententData.personPost
                    : "",
                rules: [{ required: true, message: "请输入被反映人职务" }],
              })}
              clear
              error={!!getFieldError("personPost")}
              onErrorClick={() => {
                alert(getFieldError("personPost").join("、"));
              }}
              placeholder="请输入被反映人职务"
              labelNumber={8}
              maxLength={50}
            >
              <span style={{ color: "red", width: "2rem" }}>*</span>{" "}
              被反映人职务
            </InputItem>
            {/* <Picker
              data={this.state.leibieData}
              cols={2}
              {...getFieldProps("complaintType", {
                initialValue:
                  cententData && cententData.complaintType
                    ? cententData.complaintType
                    : [],
                rules: [{ required: true, message: "请选择问题类别" }],
              })}
              title="选择问题类别"
              onOk={this.leibieOk}
            >
              <List.Item arrow="horizontal">
                <span style={{ color: "red" }}>*</span> 问题类别
              </List.Item>
            </Picker> */}
            <div className="textAre-title" style={{ fontSize: "0.17rem" }}>
              <span style={{ color: "red" }}>*</span> 主要诉求
            </div>
            <div
              {...getFieldProps("mainAppeal", {
                initialValue:
                  cententData && cententData.mainAppeal
                    ? cententData.mainAppeal
                    : "",
                rules: [{ required: true, message: "请输入主要诉求" }],
              })}
              style={{ padding: "0 0.15rem" }}
            >
              <SentsitiveCont
                blurData={this.changeBlur}
                placelder="请输入主要诉求，500字以内"
                styles={{ height: "2rem" }}
                maxCount={500}
                id="appleCont"
                initVal={
                  cententData && cententData.mainAppeal
                    ? cententData.mainAppeal
                    : ""
                }
              />
            </div>
            <div className="textAre-title" style={{ fontSize: "0.17rem" }}>
              <span style={{ color: "red" }}>*</span> 事实和理由
            </div>
            <div
              {...getFieldProps("complaintReason", {
                initialValue:
                  cententData && cententData.complaintReason
                    ? cententData.complaintReason
                    : "",
                rules: [{ required: true, message: "请输入事实和理由" }],
              })}
              style={{ padding: "0 0.15rem" }}
            >
              <SentsitiveCont
                blurData={this.shichangeBlur}
                placelder="请输入事实和理由，900字以内"
                styles={{ height: "3rem" }}
                maxCount={900}
                id="shileCont"
                initVal={
                  cententData && cententData.complaintReason
                    ? cententData.complaintReason
                    : ""
                }
              />
            </div>
            <Item
              arrow="horizontal"
              extra={
                <div
                  onClick={() => {
                    this.props.history.push({
                      pathname: "/asscate",
                      state: {
                        lianType: "add",
                      },
                    });
                    let formData = this.props.form.getFieldsValue();
                    tool.set("formData", formData);
                  }}
                >
                  +添加联名人
                </div>
              }
            >
              {`联名人数${asscateData.length}人`}
            </Item>
            <Item
              extra={
                <Switch
                  {...getFieldProps("hasPosition", {
                    initialValue:
                      cententData && cententData.hasPosition
                        ? cententData.hasPosition
                        : false,
                    valuePropName: "checked",
                  })}
                />
              }
            >
              是否有复核意见书
            </Item>
            <Item
              extra={
                <Switch
                  {...getFieldProps("isAccept", {
                    initialValue:
                      cententData && cententData.isAccept
                        ? cententData.isAccept
                        : false,
                    valuePropName: "checked",
                  })}
                />
              }
            >
              法院是否已受理
            </Item>
            <Item
              extra={
                <Switch
                  {...getFieldProps("isReview", {
                    initialValue:
                      cententData && cententData.isReview
                        ? cententData.isReview
                        : false,
                    valuePropName: "checked",
                  })}
                />
              }
            >
              是否已行政复议
            </Item>
            <Item
              extra={
                <Switch
                  {...getFieldProps("isArbitrate", {
                    initialValue:
                      cententData && cententData.isArbitrate
                        ? cententData.isArbitrate
                        : false,
                    valuePropName: "checked",
                  })}
                />
              }
            >
              仲裁机构是否已受理
            </Item>
            {/* <Item
              extra={
                <Switch
                  {...getFieldProps("isPublic", {
                    initialValue:
                      cententData && cententData.isPublic
                        ? cententData.isPublic
                        : false,
                    valuePropName: "checked",
                  })}
                />
              }
            >
              是否允许公开
            </Item> */}
          </List>
          <Item>
            <div className="footer-btn">
              <Button type="primary" inline onClick={this.onSubmit}>
                预览
              </Button>
              <Button
                type="ghost"
                inline
                onClick={() => {
                  this.props.history.goBack();
                }}
              >
                取消
              </Button>
            </div>
          </Item>
        </form>
      </div>
    );
  }
}
export default createForm()(Volation);
